import { find, get } from "lodash";
import React, { Component } from "react";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { partnerInfo } from "~/configs/partnerDetails";

const HuongDanGeneral = Loadable({
  loader: () => import("~/detect_devices/HuongDanGeneral"),
  loading: LoadableLoading
});

class HuongDanApp extends Component {
  render() {
    const info = get(partnerInfo, "menu");
    const procedureInfo = find(info, { key: "quy-trinh" });
    return (
      <div style={{ marginTop: "calc(-7vh)" }}>
        <HuongDanGeneral procedureInfo={procedureInfo} />
      </div>
    );
  }
}

export default connect()(HuongDanApp);
